export default __webpack_public_path__ + "static/media/move_fast_reject.4f035637.svg";